import { JSX, useState } from "react";
import { SelectField } from "@hatch-digital-nl/abs-storybook/legacy";
import {
    setFormValues,
    setFunctionGroupInputValue,
} from "../EditEmployeeModalSlice";
import { Dispatch } from "redux";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    formValues: {
        functionGroups: {
            selectedId: string;
            selectedValue: string;
        }[];
    };
    functionGroupInputValue?: string;
    functionGroupOptions: {
        label: string;
        value: string;
    }[];
    dispatch: Dispatch;
}

export const SelectFieldComponent = (props: Props): JSX.Element => {
    const {
        formValues,
        functionGroupInputValue,
        functionGroupOptions,
        dispatch,
    } = props;

    const [selectFieldError, setSelectFieldError] = useState<string | null>(
        null,
    );
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-employee-modal__form-group"}>
            <label htmlFor={fieldId}>Functiegroep</label>
            <div ref={fieldRef}>
                <SelectField
                    placeHolder={"Zoek functiegroep..."}
                    options={functionGroupOptions}
                    searchIcon={true}
                    required={true}
                    isMulti={true}
                    onChange={(
                        newValue: { value: string; label: string }[],
                    ) => {
                        dispatch(
                            setFormValues({
                                ...formValues,
                                functionGroups: newValue.map((item) => ({
                                    selectedId: item.value,
                                    selectedValue: item.label,
                                })),
                            }),
                        );
                        setSelectFieldError(null);
                    }}
                    value={
                        formValues?.functionGroups?.length > 0
                            ? formValues.functionGroups.map(
                                  (functionGroup) => ({
                                      value: functionGroup.selectedId,
                                      label: functionGroup.selectedValue,
                                  }),
                              )
                            : []
                    }
                    onInputChange={(inputValue: string) => {
                        dispatch(setFunctionGroupInputValue(inputValue));
                    }}
                    inputValue={functionGroupInputValue}
                    onBlur={() => {
                        if (!formValues?.functionGroups?.length) {
                            setSelectFieldError("Functiegroep is verplicht.");
                            return;
                        }

                        setSelectFieldError(null);
                    }}
                    error={!!selectFieldError}
                />
            </div>
            {selectFieldError && (
                <p className={"c-error-message"}>{selectFieldError}</p>
            )}
        </div>
    );
};
